import {createRouter, createWebHistory} from 'vue-router';
import Frame from "@/components/Layout/Frame.vue";

function loadView(view) {
    return () => import(`@/pages/${view}.vue`);
}


const router = createRouter({
    hashbang: false,
    history: createWebHistory(),
    routes: [
        {
          path: '/login',
          name: 'login',
          component: loadView("auth/formLogin"),
          meta: {
            auth: false,
            tab: false,
            title: 'Login',
          }
        },
        {
            path: "/",
            component: Frame,
            children: [
        {
            path: '/',
            name: 'home',
            component: loadView("home/dashboardAdmin"),
            meta: {
                auth: true,
                closable: false,
                title: 'Dashboard',
                icon: "fa-solid fa-house",
                tabClass: "onlyIcon",
            }
        },
        {
            path: '/articles',
            name: 'articles',
            component: loadView("article/entryArticle"),
            meta: {
                auth: true,
                tab: false,
                title: 'Artikel',
            }
        },
        {
            path: '/crm',
            name: 'crm',
            component: loadView("crm/entryCrm"),
            meta: {
                auth: true,
                tab: false,
                icon: "fa-solid fa-magnifying-glass",
                title: 'Firmen',
            }
        },
        {
            path: '/crm/abc',
            name: 'abc',
            component: loadView("crm/SalesManagerABC"),
            meta: {
                auth: true,
                tab: false,
                title: 'ABC-Analyse',
                icon: "fa-solid fa-chart-pyramid",
            }
        },
        {
            path: '/crm',
            name: 'crm',
            component: loadView("crm/crmSearch"),
            meta: {
                auth:{
                    roles: ['searchCompany'],
                    rolesKey: 'roles.crm'
                },
                icon: "fa-solid fa-magnifying-glass",
                title: 'i18n:tabs.companies',
            },
        },
        {
            path: '/crm/kontakte',
            name: 'crmContacts',
            component: loadView("crm/crmSearchContacts"),
            meta: {
                auth:{
                    roles: ['searchContacts'],
                    rolesKey: 'roles.crm'
                },
                //auth: true,
                icon: "fa-solid fa-magnifying-glass",
                title: 'i18n:tabs.contacts',
            },
        },
        {
            path: '/crm/shopusers',
            name: 'crmShopUsers',
            component: loadView("crm/crmSearchShopUser"),
            meta: {
                auth:{
                    roles: ['searchContacts'],
                    rolesKey: 'roles.crm'
                },
                //auth: true,
                icon: "fa-solid fa-magnifying-glass",
                title: 'Shop-Benutzer',
            },
        },
        {
            path: '/crm/shopuser/:userId',
            name: 'crmShopUser',
            component: loadView("crm/ShopUser"),
            meta: {
                auth:{
                    roles: ['searchShopusers'],
                    rolesKey: 'roles.crm'
                },
                //auth: true,
                title: 'Shopbenutzer',
                icon: "fa-solid fa-cart-shopping",
                key: 'path'
            },
        },
        {
            path: '/crm/flagging',
            name: 'flagging',
            component: loadView("crm/editFlagging"),
            meta: {
                auth:{
                    roles: ['editFlagging'],
                    rolesKey: 'roles.crm'
                },
                //auth: true,
                title: 'Flagging',
                icon: "fa-solid fa-flag ",
            },
        },
        {
            path: '/crm/:id',
            name: 'company',
            component: loadView("crm/CompanyDetails"),
            meta: {
                auth: true,
                tab: false,
                title: 'Firma',
                key: 'path',
            }
        },
        {
            path: '/crm/kontakt/:contactId',
            name: 'contact',
            component: loadView("crm/CompanyContact"),
            meta: {
                auth: true,
                tab: false,
                title: 'Kontakt',
                icon: "fa-solid fa-user",
                key: 'path',
            },
        },
        {
            path: '/crm/adresse/:addressId',
            name: 'address',
            component: loadView("crm/CompanyAddress"),
            meta: {
                auth: true,
                tab: false,
                title: 'Adresse',
                icon: "fa-solid fa-map-location-dot",
                key: 'path',
            },
        },
        {
            path: '/artikel/',
            name: 'articles',
            component: loadView("article/articleSearch"),
            meta: {
                auth: true,
                tab: false,
                icon: "fa-solid fa-magnifying-glass",
                title: 'Artikel',
            },
            props: route => ({ modus: route.query.modus })
        },
        {
            path: '/artikel/bestellung/:id',
            name: 'articleOrder',
            component: loadView("article/articleOrder"),
            meta: {
                auth: true,
                tab: false,
                icon: "fa-solid fa-bag-shopping",
                title: 'Bestellung',
                key: 'path'
            },
        },
        {
            path: '/artikel/bestellung',
            name: 'articleOrders',
            component: loadView("article/articleOrders"),
            meta: {
                auth: true,
                tab: false,
                icon: "fa-solid fa-magnifying-glass",
                title: 'Bestellungen',
            },
        },
        {
            path: '/artikel/:id',
            name: 'article',
            component: loadView("article/articleDetail"),
            meta: {
                auth: true,
                tab: false,
                icon: "fa-solid fa-file-certificate",
                title: 'Artikel',
                key: 'path',
            },
        },
        {
            path: '/angebot/neu',
            name: 'createOffer',
            component: loadView("offer/CreateOffer"),
            meta: {
                auth:{
                    roles: ['editFlagging'],
                    rolesKey: 'roles.crm'
                },
                title: 'Neues Angebot',
                tab: false
            },
        },
        {
            path: '/angebot/:id',
            name: 'offer',
            component: loadView("offer/CreateOffer"),
            meta: {
                auth: true,
                tab: false,
                title: 'Angebot',
                icon: "fa-solid fa-handshake",
                key: 'path',
            },
        },
        {
            path: '/angebote',
            name: 'offers',
            component: loadView("offer/offerSearch"),
            meta: {
                auth: true,
                tab: false,
                title: 'i18n:tabs.offers',
                icon: "fa-solid fa-magnifying-glass",
            },
        },
        {
            path: '/angebotsfreigabe',
            name: 'releaseOffers',
            component: loadView("offer/releaseOffers"),
            meta: {
                auth: true,
                tab: false,
                title: 'Angebotefreigabe',
                icon: "fa-solid fa-tower-control",
            },
        },
        {
            path: '/angebotsfreigabe/archiv',
            name: 'releaseOfferOverview',
            component: loadView("offer/releaseOfferOverview"),
            meta: {
                auth: true,
                tab: false,
                title: 'Archive Angebotefreigabe',
                icon: "fa-solid fa-tower-control",
            },
        },
        {
            path: '/berichte/mitarbeiter/:id',
            name: 'employerReport',
            component: loadView("reports/employerReport"),
            meta: {
                auth: true,
                tab: false,
                icon: 'fa-solid fa-chart-line',
                title: 'Bericht',
                key: 'path'
            },
        },
        {
            path: '/dev',
            name: 'dev',
            component: loadView("dev/devPage"),
            meta: {
                auth: true,
                tab: false
            },
        },
        {
            path: '/users',
            name: 'users',
            component: loadView("settings/SettingsUser"),
            meta: {
                auth: true,
                tab: false,
                icon: "fa-solid fa-users",
                title: 'Benutzer',
            },
        },
        {
            path: '/holidays',
            name: 'holidays',
            component: loadView("settings/SettingHolidays"),
            meta: {
                auth: true,
                tab: false,
              icon: "fa-solid fa-calendar-heart",
              title: 'Feiertage',
            },
        },
        {
            path: '/403',
            name: 'forbidden',
            component: loadView("errors/forbidden"),
            meta: {
                auth: true,
                tab: false
            },
        },
        {
            path: '/account',
            name: 'account',
            component: loadView("fibu/AccountView"),
            meta: {
                auth:{
                    roles: ['showAccount'],
                    rolesKey: 'roles.fibu'
                },
                title: "Konten",
                icon: "fa-solid fa-building-columns",
                tab: false
            },
        },
        {
            path: '/rechungen',
            name: 'invoices',
            component: loadView("fibu/searchInvoice"),
            meta: {
                auth:{
                    roles: ['showAccount'],
                    rolesKey: 'roles.fibu'
                },
                title: "Rechnungen",
                icon: "fa-solid fa-magnifying-glass",
                tab: false
            },
        },
        {
            path: '/callparty',
            name: 'callparty',
            component: loadView("callparty/callparty"),
            meta: {
                tab: false,
                title: 'CallParty',
                icon: "fa-solid fa-headset",
            },
        },
        {
            path: '/provisionen',
            name: 'provisions',
            component: loadView("fibu/provisions"),
            meta: {
                auth:{
                    roles: ['showAccount'],
                    rolesKey: 'roles.fibu'
                },
                title: "Provisionen",
                icon: "fa-solid fa-droplet-percent",
                tab: false
            },
        },
        {
            path: '/rechung/:id',
            name: 'invoice',
            component: loadView("fibu/invoice"),
            meta: {
                auth:{
                    roles: ['showAccount'],
                    rolesKey: 'roles.fibu'
                },
                title: "Rechnung",
                icon: "fa-solid fa-file-invoice",
                key: 'path',
                tab: false
            },
        },
        {
            path: '/auftragsverarbeitung',
            name: 'orders',
            component: loadView("order/orderOverview"),
            meta: {
                auth:{
                    roles: ['processOrders'],
                    rolesKey: 'roles.erp'
                },
                title: "Aufträge",
                icon: "fa-solid fa-magnifying-glass",
                key: 'path',
                tab: false
            },
            props: route => ({ modus: route.query.modus })
        },
        {
            path: '/archiv',
            name: 'archive',
            component: loadView("history/searchOrderHistory"),
            meta: {
                auth:{
                    roles: ['processOrders'],
                    rolesKey: 'roles.erp'
                },
                tab: false,
                title: "Archiv",
                icon: "fa-solid fa-magnifying-glass",
            },
        },
        {
            path: '/archiv/:id',
            name: 'historyOrder',
            component: loadView("history/OrderHistory"),
            meta: {
                auth:{
                    roles: ['processOrders'],
                    rolesKey: 'roles.erp'
                },
                tab: false,
                title: "Archivauftrag",
                icon: "fa-solid fa-box-archive",
                key: 'path'
            },
        },
        {
            path: '/auftrag/:id',
            name: 'order',
            component: loadView("order/Order"),
            meta: {
                auth:{
                    roles: ['processOrders'],
                    rolesKey: 'roles.erp'
                },
                tab: false,
                title: 'Auftrag',
                icon: "fa-solid fa-arrow-progress",
                key: 'path'
            },
        }
        ]}
    ]
});

export default (app) => {
    app.router = router;
    app.use(router);
}